<template>
  <b-modal :id="modalId" centered hide-header size="sm" @ok="hideMedia">
    <div class="d-block text-center">
      <Icon name="grTrash" width="36" class="mb-3"/>
      <h5 class="modal-title mb-2">{{ $t('modal_remove_photo.title') }}</h5>
      <div class="modal-subtitle">{{ $t('modal_remove_photo.subtitle') }}</div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 ml-sm-2 mb-2 mb-sm-0">
            <b-button variant="danger" block @click="ok()">
              {{ $t('modal_remove_photo.action_confirm') }}
            </b-button>
          </div>
          <div class="flex-grow-1 order-sm-0 mr-sm-2">
            <b-button variant="light" block @click="cancel()">
              {{ $t('modal_remove_photo.action_cancel') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
import EventService from "@/services/Event.js"

export default {
  props: ['mediaId'],

  created() {
    this.modalId = 'modal-remove-media'
  },
  methods: {
    hideMedia() {
      EventService.hideMedia(this.mediaId).then(() => {
        this.$bvModal.hide(this.modalId)
        this.$emit('media-removed', this.mediaId)
      }).catch(error => {
        if (error.response.status === 404 || error.response.status === 403) {
          this.$bvToast.toast(
              this.$t('notifications.photo_not_removed_from_checkin'),
              {variant: 'danger', autoHideDelay: 5000})
        }
      })
    }
  }
}
</script>

